<template>
  <div ref="chart">
    <Chart :height="height" :id="id" :option="option" :width="width"></Chart>
  </div>
</template>

<script>
import Chart from '@/components/echarts/Chart';

export default {
  name: "HumitureBarChart",
  components: { Chart },
  props: {
    data: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      id: "HumitureBarChart_" + Math.random().toString(36).substr(2, 9),
      width: '100%',
      height: '100%',
      option: {}
    };
  },
  watch: {
    data: {
      handler() {
        this.getOption();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.getOption();
  },
  methods: {
    getOption() {
      if (!this.data) return;
      
      const { spaceNames, temperatures, humidities } = this.data;
      
      this.option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            let result = params[0].name + '<br/>';
            params.forEach(item => {
              const unit = item.seriesName === '温度' ? '℃' : '%';
              result += item.marker + item.seriesName + ': ' + item.value + unit + '<br/>';
            });
            return result;
          }
        },
        legend: {
          data: ['温度', '湿度'],
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
          top: 10,
          left: 'center'
        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: spaceNames,
          axisLine: {
            lineStyle: {
              color: 'rgba(73, 164, 243, .4)'
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 11,
            interval: 0,
            rotate: 0,
            formatter: function(value) {
              // 名称过长时截断显示
              if (value.length > 6) {
                return value.substring(0, 6) + '...';
              }
              return value;
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '温度(℃)',
            nameTextStyle: {
              color: '#299BFF',
              fontSize: 11
            },
            position: 'left',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(73, 164, 243, .4)'
              }
            },
            axisLabel: {
              color: '#299BFF',
              fontSize: 11
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: 'rgba(73, 164, 243, .2)'
              }
            }
          },
          {
            type: 'value',
            name: '湿度(%)',
            nameTextStyle: {
              color: '#32CFD2',
              fontSize: 11
            },
            position: 'right',
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(73, 164, 243, .4)'
              }
            },
            axisLabel: {
              color: '#32CFD2',
              fontSize: 11
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '温度',
            type: 'bar',
            barWidth: '20%',
            barGap: '90%',
            yAxisIndex: 0,
            data: temperatures,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(41, 155, 255, 1)' },
                  { offset: 0.5, color: 'rgba(41, 155, 255, 0.7)' },
                  { offset: 1, color: 'rgba(41, 155, 255, 0.3)' }
                ]
              },
              borderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              position: 'top',
              color: '#299BFF',
              fontSize: 9,
              formatter: '{c}℃',
            }
          },
          {
            name: '湿度',
            type: 'bar',
            barWidth: '20%',
            yAxisIndex: 1,
            data: humidities,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(50, 207, 210, 1)' },
                  { offset: 0.5, color: 'rgba(50, 207, 210, 0.7)' },
                  { offset: 1, color: 'rgba(50, 207, 210, 0.3)' }
                ]
              },
              borderRadius: [4, 4, 0, 0]
            },
            label: {
              show: true,
              position: 'top',
              color: '#32CFD2',
              fontSize: 9,
              formatter: '{c}%',
            }
          }
        ]
      };
    }
  }
}
</script>

<style scoped>
</style>
